import { ref, onMounted, computed } from 'vue';
import ContactForm from '@/components/ContactForm.vue';
import ConsultationLeadForm from '@/components/forms/ConsultationLeadForm/ConsultationLeadForm.vue';
import EmbeddedLiveChat from '@/components/forms/ChatLive/EmbeddedLiveChat.vue';

export function useContactOptions() {
    const mode = ref<'ticket' | 'consult' | 'chat' | ''>('');
    const isChatLive = ref(false);

    function setMode(value: 'ticket' | 'consult' | 'chat') {
        mode.value = mode.value === value ? '' : value;
    }

    const currentComponent = computed(() =>
        mode.value === 'ticket'
            ? ContactForm
            : mode.value === 'consult'
                ? ConsultationLeadForm
                : EmbeddedLiveChat
    );

    onMounted(() => {
        ; (window as any).Tawk_API = (window as any).Tawk_API || {};
        ; (window as any).Tawk_API.onStatusChange = (s: string) => {
            isChatLive.value = s === 'online';
        };
    });

    return { mode, isChatLive, setMode, currentComponent };
}
